module.exports = __webpack_public_path__ + "images/backgrounds/subtle-irongrip.c9f15836db29df79c2a0.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/subtle-irongrip.png
// module id = u0kZ
// module chunks = 1